import axios from "axios";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

const apiUrlEmpresas = `${process.env.REACT_APP_API_URL}/empresas`;

function AbmEmpresas() {
    const [empresas, setEmpresas] = useState([])
    const [isLoading, setIsLoading] = useState(true)
    const [showModal, setShowModal] = useState(false)
    const [empresaAEliminar, setEmpresaAEliminar] = useState(null)
    const navigate = useNavigate();

    useEffect(() => {
        getEmpresas()
    }, [])

    const getEmpresas = async () => {
        try {
            setIsLoading(true)
            const res = await axios.get(apiUrlEmpresas)
            setEmpresas(res.data)
        } catch (error) {
            console.error("Error al obtener empresas:", error)
            alert('❌ Error al cargar las empresas')
        } finally {
            setIsLoading(false)
        }
    };

    const confirmarEliminacion = (empresa) => {
        setEmpresaAEliminar(empresa)
        setShowModal(true)
    }

    const deleteEmpresa = async () => {
        try {
            await axios.delete(`${apiUrlEmpresas}/${empresaAEliminar.id_empresa}`);
            alert('✅ Empresa eliminada correctamente')
            setShowModal(false)
            setEmpresaAEliminar(null)
            getEmpresas();
        } catch (error) {
            console.error("Error al eliminar empresa:", error);
            alert('❌ Error al eliminar la empresa: ' + (error.response?.data?.message || error.message));
        }
    };

    const toggleEstado = async (empresa) => {
        try {
            console.log('[toggleEstado] Cambiando estado de empresa:', empresa.id_empresa, 'Estado actual:', empresa.activo);
            const response = await axios.patch(`${apiUrlEmpresas}/${empresa.id_empresa}/toggle`);
            console.log('[toggleEstado] Respuesta:', response.data);
            alert('✅ Estado actualizado correctamente');
            getEmpresas();
        } catch (error) {
            console.error("[toggleEstado] Error al cambiar estado:", error);
            alert('❌ Error al cambiar el estado: ' + (error.response?.data?.message || error.message));
        }
    };

    if (isLoading) {
        return (
            <div className="min-h-screen bg-gradient-to-br from-purple-50 via-indigo-50 to-blue-100 flex items-center justify-center">
                <div className="bg-white p-8 rounded-2xl shadow-xl">
                    <div className="flex items-center gap-4">
                        <svg className="animate-spin h-8 w-8 text-purple-600" viewBox="0 0 24 24">
                            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" fill="none" />
                            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
                        </svg>
                        <span className="text-lg font-semibold text-gray-700">Cargando empresas...</span>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="min-h-screen bg-gradient-to-br from-purple-50 via-indigo-50 to-blue-100 py-8 px-4">
            <div className="max-w-7xl mx-auto">
                {/* Header */}
                <div className="bg-white rounded-2xl shadow-xl p-6 mb-6 border-b-4 border-purple-500">
                    <div className="flex items-center justify-between">
                        <div className="flex items-center gap-4">
                            <div className="bg-gradient-to-br from-purple-500 to-indigo-600 p-4 rounded-xl shadow-lg">
                                <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                                </svg>
                            </div>
                            <div>
                                <h1 className="text-3xl font-bold text-gray-800">Gestión de Empresas</h1>
                                <p className="text-gray-600 mt-1">Administra las empresas del sistema</p>
                            </div>
                        </div>
                        <button
                            onClick={() => navigate('/admin/CreateEmpresa')}
                            className="bg-gradient-to-r from-purple-600 to-indigo-600 text-white font-bold py-3 px-6 rounded-lg shadow-lg hover:from-purple-700 hover:to-indigo-700 transform hover:scale-105 transition-all flex items-center gap-2"
                        >
                            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
                            </svg>
                            Nueva Empresa
                        </button>
                    </div>
                </div>

                {/* Tabla */}
                <div className="bg-white rounded-2xl shadow-xl overflow-hidden">
                    <div className="overflow-x-auto">
                        <table className="w-full">
                            <thead className="bg-gradient-to-r from-purple-600 to-indigo-600 text-white">
                                <tr>
                                    <th className="px-6 py-4 text-left text-sm font-bold uppercase tracking-wider">Nombre</th>
                                    <th className="px-6 py-4 text-left text-sm font-bold uppercase tracking-wider">Razón Social</th>
                                    <th className="px-6 py-4 text-left text-sm font-bold uppercase tracking-wider">CUIT</th>
                                    <th className="px-6 py-4 text-left text-sm font-bold uppercase tracking-wider">Teléfono</th>
                                    <th className="px-6 py-4 text-left text-sm font-bold uppercase tracking-wider">Email</th>
                                    <th className="px-6 py-4 text-center text-sm font-bold uppercase tracking-wider">Estado</th>
                                    <th className="px-6 py-4 text-center text-sm font-bold uppercase tracking-wider">Acciones</th>
                                </tr>
                            </thead>
                            <tbody className="divide-y divide-gray-200">
                                {empresas.length === 0 ? (
                                    <tr>
                                        <td colSpan="7" className="px-6 py-12 text-center text-gray-500">
                                            <div className="flex flex-col items-center gap-3">
                                                <svg className="w-16 h-16 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                                                </svg>
                                                <p className="text-lg font-semibold">No hay empresas registradas</p>
                                                <p className="text-sm">Crea una nueva empresa para comenzar</p>
                                            </div>
                                        </td>
                                    </tr>
                                ) : (
                                    empresas.map((empresa) => (
                                        <tr key={empresa.id_empresa} className="hover:bg-purple-50 transition-colors">
                                            <td className="px-6 py-4">
                                                <span className="font-bold text-gray-800">{empresa.nombre}</span>
                                            </td>
                                            <td className="px-6 py-4 text-gray-600">{empresa.razon_social || '-'}</td>
                                            <td className="px-6 py-4 text-gray-600">{empresa.cuit || '-'}</td>
                                            <td className="px-6 py-4 text-gray-600">{empresa.telefono || '-'}</td>
                                            <td className="px-6 py-4 text-gray-600">{empresa.email || '-'}</td>
                                            <td className="px-6 py-4 text-center">
                                                <button
                                                    onClick={() => toggleEstado(empresa)}
                                                    className={`inline-flex items-center gap-2 px-4 py-2 rounded-lg font-semibold text-white transition-all transform hover:scale-105 ${empresa.activo
                                                        ? 'bg-gradient-to-r from-green-500 to-emerald-600 hover:from-green-600 hover:to-emerald-700'
                                                        : 'bg-gradient-to-r from-red-500 to-rose-600 hover:from-red-600 hover:to-rose-700'
                                                        }`}
                                                >
                                                    <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                                                        {empresa.activo ? (
                                                            <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                                                        ) : (
                                                            <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
                                                        )}
                                                    </svg>
                                                    {empresa.activo ? 'Activa' : 'Inactiva'}
                                                </button>
                                            </td>
                                            <td className="px-6 py-4">
                                                <div className="flex items-center justify-center gap-2">
                                                    <button
                                                        onClick={() => navigate(`/admin/EditEmpresa/${empresa.id_empresa}`)}
                                                        className="bg-gradient-to-r from-blue-500 to-cyan-600 text-white p-2 rounded-lg hover:from-blue-600 hover:to-cyan-700 transition-all transform hover:scale-110 shadow-md"
                                                        title="Editar"
                                                    >
                                                        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                                                        </svg>
                                                    </button>
                                                    <button
                                                        onClick={() => confirmarEliminacion(empresa)}
                                                        className="bg-gradient-to-r from-red-500 to-rose-600 text-white p-2 rounded-lg hover:from-red-600 hover:to-rose-700 transition-all transform hover:scale-110 shadow-md"
                                                        title="Eliminar"
                                                    >
                                                        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                                                        </svg>
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>
                                    ))
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>

                {/* Info card */}
                <div className="mt-6 bg-purple-50 border-l-4 border-purple-500 p-4 rounded-r-lg shadow-md">
                    <div className="flex items-start gap-3">
                        <svg className="w-6 h-6 text-purple-600 flex-shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                            <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
                        </svg>
                        <div>
                            <p className="text-sm font-semibold text-purple-900">Gestión de Empresas</p>
                            <p className="text-sm text-purple-700 mt-1">
                                Las empresas pueden contener múltiples sedes. Al eliminar una empresa, se eliminarán también todas sus sedes asociadas.
                            </p>
                        </div>
                    </div>
                </div>
            </div>

            {/* Modal de confirmación */}
            {showModal && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
                    <div className="bg-white rounded-2xl shadow-2xl max-w-md w-full p-6 transform transition-all">
                        <div className="flex items-center gap-4 mb-4">
                            <div className="bg-red-100 p-3 rounded-full">
                                <svg className="w-6 h-6 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
                                </svg>
                            </div>
                            <div>
                                <h3 className="text-xl font-bold text-gray-800">Confirmar Eliminación</h3>
                                <p className="text-sm text-gray-600">Esta acción no se puede deshacer</p>
                            </div>
                        </div>
                        <p className="text-gray-700 mb-2">
                            ¿Está seguro que desea eliminar la empresa <span className="font-bold text-purple-600">{empresaAEliminar?.nombre}</span>?
                        </p>
                        <div className="bg-red-50 border-l-4 border-red-500 p-3 rounded-r-lg mb-6">
                            <p className="text-sm text-red-800 font-semibold">
                                ⚠️ Esta acción eliminará todas las sedes asociadas a esta empresa.
                            </p>
                        </div>
                        <div className="flex gap-3">
                            <button
                                onClick={deleteEmpresa}
                                className="flex-1 bg-gradient-to-r from-red-600 to-rose-600 text-white font-bold py-3 px-6 rounded-lg hover:from-red-700 hover:to-rose-700 transition-all transform hover:scale-105"
                            >
                                Eliminar
                            </button>
                            <button
                                onClick={() => { setShowModal(false); setEmpresaAEliminar(null); }}
                                className="flex-1 bg-gray-200 hover:bg-gray-300 text-gray-700 font-bold py-3 px-6 rounded-lg transition-all transform hover:scale-105"
                            >
                                Cancelar
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    )
}

export default AbmEmpresas;
